import { z } from "zod";
export { FileIndexSchema } from "../readExcel/readExcel.schema";
export const SearchTypeSchema = z
    .enum(["vector", "fuzzy", "exact"])
    .describe("Search algorithm: vector (semantic), fuzzy (approximate), exact (precise)");
export const SearchOperatorSchema = z
    .enum(["or", "and"])
    .describe("Combine phrases with OR (any match) or AND (all required)");
export const CellsOrChartsSchema = z
    .enum(["cells", "charts", "both"])
    .describe("Excel-only filter: cells, charts, or both");
export const SearchFilesParamsSchema = z.object({
    uiDescription: z
        .string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    phrases: z
        .array(z.string())
        .min(1, "Must provide at least one search phrase")
        .describe("Search keywords/phrases to look for"),
    searchType: SearchTypeSchema.optional().default("vector"),
    searchOperator: SearchOperatorSchema.optional().default("or"),
    searchFiles: z
        .union([
        z.array(z.union([z.number().int().nonnegative(), z.string()])),
        z.literal("current"),
        z.literal("all"),
    ])
        .optional()
        .describe("File indexes [0,1,2], filepath strings, 'current', or 'all'"),
    excludeFiles: z
        .array(z.number().int().nonnegative())
        .optional()
        .describe("File indexes to exclude"),
    ignoreIds: z.array(z.string()).optional().describe("Page IDs/chunk IDs to exclude"),
    moreLike: z.array(z.string()).optional().describe("Chunk IDs to find similar content"),
    cellsOrCharts: CellsOrChartsSchema.optional(),
    sheetName: z.string().optional(),
    pageNumber: z.number().int().positive().optional(),
    purpose: z.string().optional(),
    numResults: z.number().int().min(1).max(20).optional().default(3),
});
